export const cutString = (string, length, start, decorator) => {
    return string?.length > length ? `${string?.slice(start || 0, length)}${decorator}` : string;
}


export const dateFine = (date) => {
    if (!date || typeof date !== 'string') return '';

    if (!date.includes('T')) {
        return date;
    }

    const newDateSplited = date.split('T');

    const day = newDateSplited?.[0] || '';

    const hour = newDateSplited?.[1]?.split('.')?.[0] || newDateSplited?.[1] || '';

    return `${day} ${hour}`.trim();
}


export const handleLoadSelectOptions = async (e, functionGetter, additionalParams, valueKey, labelKey) => {
    const getData = await functionGetter({ params: { name: e, perPage: 50, page: 1, ...additionalParams } }, { useCache: false });
    return mapValues(getData?.data?.data, valueKey, labelKey);
}

export const mapValues = (values, valueKey = null, labelKey = null) => {
    const valuesMapped = values.map((value) => {
        return {
            label: labelKey ? value?.[labelKey] : value?.name,
            value: valueKey ? value?.[valueKey] : value?.id
        }
    });
    return valuesMapped;
}